import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import IconButton from '@mui/material/IconButton';

const ButtonContainer = ({index, selectedPattern, setIsSplit}) => {
    return (
        <Stack>
            <IconButton aria-label="split" onClick={setIsSplit(index)}>
                <SplitscreenIcon sx={{fontSize:50, transform: 'rotate(90deg)'}}/> 
            </IconButton>
        </Stack>
    )
}


const Droppable = ({selectedImages, dimensions, selectedPattern,  height, index, chunks, setChunks, movie}) => {

    const [isDragging, setIsDragging] = useState(false);
    const [selectedRef, setSelectedRef] = useState()
    const [width, setWidth] = useState(0)
    const {crop} = movie;
    useEffect(()=>{
        //setWidth(dimensions.width/dimensions.height * height/parseInt(selectedPattern))
        setWidth((dimensions.width/dimensions.height) * ((height-(10*parseInt(selectedPattern)-1))/parseInt(selectedPattern)))
    }, [dimensions, width])
    const canvasRef = useRef(null);
    const canvasRefTwo = useRef(null);
    useEffect(()=> {
        if (chunks[index].isSplit) {
            if (canvasRef.current && canvasRefTwo.current) {
                if (chunks[index].lfile) {
                    const canvas = canvasRef.current;
                    const ctx = canvas.getContext('2d');
                    canvas.addEventListener('mousedown', (e) => {
                        let startX = e.clientX;
                        let x = chunks[index].lfilex
                        canvas.addEventListener('mousemove', onMouseMove);

                        canvas.addEventListener('mouseup', () => {
                            canvas.removeEventListener('mousemove', onMouseMove);
                        });

                        function onMouseMove(e) {
                            const diffX = e.clientX - startX;
                            x += diffX; // Update the X-axis position
                            if (x<=0 && x >= ((dimensions.width/2)*-1)) {
                                const _chunks = [...chunks];
                                const chunk = _chunks[index]
                                chunk.lfilex = x
                                setChunks(_chunks)
                            }
                            startX = e.clientX;
                        }
                    });
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        const img = new Image();
                        img.onload = () => {
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        // Draw the image on the canvas
                        ctx.drawImage(img, 0-chunks[index].lfilex+crop?.left??0, crop?.top??0, dimensions.width/2, dimensions.height, 0,0,width/2,canvas.height);
                        };
                        img.src = event.target.result;
                    };
                    reader.readAsDataURL(chunks[index].lfile);
                }
                if (chunks[index].rfile) {
                    const canvas = canvasRefTwo.current;
                    const ctx = canvas.getContext('2d');
                    const reader = new FileReader();
                    canvas.addEventListener('mousedown', (e) => {
                        let x = chunks[index].rfilex
                        let startX = e.clientX
                        canvas.addEventListener('mousemove', onMouseMove);

                        canvas.addEventListener('mouseup', () => {
                            canvas.removeEventListener('mousemove', onMouseMove);
                        });

                        /*function onMouseMove(e) {
                            const diffX = e.clientX - startX;
                            x += diffX; // Update the X-axis position
                            if (x<=0 && x >= ((dimensions.width/2)*-1)) {
                                const _chunks = [...chunks];
                                const chunk = _chunks[index]
                                chunk.rfilex = x
                                setChunks(_chunks)
                            }
                            startX = e.clientX;
                        }*/
                        function onMouseMove(e) {
                            const diffX = e.clientX - startX;
                            x -= diffX; // Update the X-axis position
                            if (x<=0 && x >= ((dimensions.width/2)*-1)) {
                                const _chunks = [...chunks];
                                const chunk = _chunks[index]
                                chunk.rfilex = x
                                setChunks(_chunks)
                            }
                            startX = e.clientX;
                        }
                    });
                    reader.onload = (event) => {
                        const img = new Image();
                        img.onload = () => {
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        // Draw the image on the canvas
                        //ctx.drawImage(img, 0-chunks[index].rfilex+crop?.left ?? 0, crop?.top ?? 0, dimensions.width/2, dimensions.height, 0,0,width/2, canvas.height);
                        ctx.drawImage(img, ((chunks[index].rfilex+crop?.left ?? 0)+(dimensions.width/2)), crop?.top ?? 0, dimensions.width/2, dimensions.height, 0,0,width/2, canvas.height);
                        };
                        img.src = event.target.result;
                    };
                    reader.readAsDataURL(chunks[index].rfile);
                }
            }
        } else {
            if (canvasRef.current && chunks[index].file) {
                const canvas = canvasRef.current;
                const ctx = canvas.getContext('2d');
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                    // Draw the image on the canvas
                    ctx.drawImage(img, crop.left ?? 0, crop?.top ?? 0, dimensions.width, dimensions.height, 0, 0, canvas.width, canvas.height);
                    };
                    img.src = event.target.result;
                };
                reader.readAsDataURL(chunks[index].file);
            }
        }
    }, [chunks])

    const handleMouseDown = () => {
        setIsDragging(true);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const setIsSplit = (_index) => {
        return () => {
            const _chunks = [...chunks];
            const chunk = _chunks[_index];
            if (chunk.isSplit) {
                chunk.isSplit = false
                delete chunk.lfile
                delete chunk.rfile
                delete chunk.lfilex
                delete chunk.rfilex
                chunk.file=undefined                
            } else {
                chunk.isSplit = true
                chunk.lfile = undefined
                chunk.rfile = undefined
                chunk.lfilex = 0
                chunk.rfilex = 0
                delete chunk.file
            }
            setChunks(_chunks)
        }
    }



    const handleDrop = (e) => {
        e.preventDefault();
        const droppedText = e.dataTransfer.getData('text/plain');
        const _chunks = [...chunks]
        const chunk = _chunks[index];
        chunk.file = selectedImages[parseInt(droppedText, 10)]
        setChunks(_chunks)
        /**/
    };

    const handleSplitDrop =(pos)=> {
        return (e) => {
            e.preventDefault();
            const droppedText = e.dataTransfer.getData('text/plain');
            const _chunks = [...chunks]
            const chunk = _chunks[index];
            const key = pos === 'left' ? 'lfile' : 'rfile'
            const posKey = pos === 'left' ? 'lfilex' : 'rfilex'
            chunk[key] = selectedImages[parseInt(droppedText, 10)]
            chunk[posKey] = 0
            setChunks(_chunks)
        }
    }
    console.log('>>', width)
    if (height && dimensions.height && dimensions.width) {
        const indHeight = (height-(10*parseInt(selectedPattern)-1))/parseInt(selectedPattern)
        if (chunks[index].isSplit) {
            return (
                <Box sx={{position: "relative", display: 'flex', alignItems:"center"}}>
                    <Stack direction="row">
                    <canvas
                        ref={canvasRef}
                        width={width/2}
                        height={indHeight}
                        style={{ border: '1px solid #ccc' }}
                        onDrop={handleSplitDrop('left')}
                        onDragOver={handleDragOver}
                    ></canvas>
                    <Box
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        sx={{
                            width: `${width/2}px`,
                            height: indHeight,
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            pointerEvents: 'none'
                        }}
                    >
                    </Box>
                    <canvas
                        ref={canvasRefTwo}
                        width={width/2}
                        height={indHeight}
                        style={{ border: '1px solid #ccc' }}
                        onDrop={handleSplitDrop('right')}
                        onDragOver={handleDragOver}
                    ></canvas>
                    <Box
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        sx={{
                            width: `${width/2}px`,
                            height: indHeight,
                            position: 'absolute',
                            top: 0,
                            left: `${width/2}`,
                            pointerEvents: 'none'
                        }}
                    >
                    </Box>
                    </Stack>
                    <ButtonContainer
                        index={index}
                        selectedPattern={selectedPattern}
                        setIsSplit={setIsSplit}
                    />         
                </Box>
            );
        }
        return (
            <Box sx={{position: "relative", display: 'flex', alignItems:"center"}}>
                <canvas
                    ref={canvasRef}
                    width={width}
                    height={indHeight}
                    style={{ border: '1px solid #ccc' }}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                ></canvas>
                <Box
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                    sx={{
                        width: `{width}px`,
                        height: indHeight,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        pointerEvents: 'none'
                    }}
                >
                </Box>
                <ButtonContainer
                    index={index}
                    selectedPattern={selectedPattern}
                    setIsSplit={setIsSplit}
                />         
            </Box>
        );
    }
    return null
};

export default Droppable
